module.exports = __webpack_public_path__ + "static/assets/ea89b5751c155bad2e6e7b766c048beb.png";